import i18n from 'helpers/i18n';
import messages from './messages';
import { useState } from 'react';
import RoutesHelper from 'helpers/routes';
import Avatar from 'components/Avatar';
import { Outlet } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import MainContent from 'components/MainContent';
import useCurrentUser from 'hooks/useCurrentUser';
import ImageUploader from 'components/Account/ImageUploader';
import imageUploaderMessages from 'components/Account/ImageUploader/messages';
import { getInitials, getFullName } from 'helpers/user';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { Button, Dialog } from '@teachstonellc/component-library';

import {
  Header,
  Wrapper,
  ContentWrapper,
  Sidebar,
  ProfileWrapper,
  ProfileName,
  NavWrapper,
  NavList,
  NavItem,
  NavLink,
  MainWrapper
} from './Styled';

function AccountPage() {
  useDocumentTitle(i18n.ft(messages.documentTitle));
  const currentUser = useCurrentUser();
  const isMediumScreen = useMediaQuery({ minWidth: 768 });
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <MainContent maxWidth={1280}>
      <Dialog
        open={isOpen}
        onOpenChange={setIsOpen}
        title={i18n.ft(imageUploaderMessages.uploadPhoto)}
      >
        <ImageUploader onClose={closeModal} />
      </Dialog>
      <Wrapper>
        <Header>{i18n.ft(messages.header)}</Header>
        <ContentWrapper>
          <Sidebar>
            <ProfileWrapper>
              <Avatar
                src={currentUser.avatar_url}
                content={getInitials(currentUser)}
                size={isMediumScreen ? 'xLarge' : 'large'}
              />
              <ProfileName>{getFullName(currentUser)}</ProfileName>
              <Button
                type="button"
                variant="secondary"
                shape="rounded"
                size="small"
                onClick={openModal}
              >
                {i18n.ft(messages.changePhoto)}
              </Button>
            </ProfileWrapper>
            <NavWrapper aria-label={i18n.ft(messages.accountNav)}>
              <NavList>
                <NavItem>
                  <NavLink end to={RoutesHelper.getPath('account')}>
                    {i18n.ft(messages.profile)}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink to={RoutesHelper.getPath('account-phone')}>
                    {i18n.ft(messages.mobileLogin)}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink to={RoutesHelper.getPath('account-password')}>
                    {i18n.ft(messages.changePassword)}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink to={RoutesHelper.getPath('account-experience')}>
                    {i18n.ft(messages.experience)}
                  </NavLink>
                </NavItem>
              </NavList>
            </NavWrapper>
          </Sidebar>
          <MainWrapper>
            <Outlet />
          </MainWrapper>
        </ContentWrapper>
      </Wrapper>
    </MainContent>
  );
}

export default AccountPage;
